interface SEOHeadProps {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogType?: string;
  ogImage?: string;
  schemaData?: Record<string, unknown>;
  pageType?: 'website' | 'article' | 'webpage';
  articleData?: {
    publishDate: string;
    modifiedDate: string;
    authorName: string;
    category: string;
    tags: string[];
  };
  breadcrumbItems?: { name: string; url: string }[];
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogType = 'website',
  ogImage,
  schemaData,
  pageType = 'webpage',
  articleData,
  breadcrumbItems,
}: SEOHeadProps) {
  const generateOrganizationSchema = () => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '今日看料',
    url: 'https://www.jinrikankan.com',
    description: '吃瓜群众的一线热点追踪站，聚合网红爆料、娱乐圈八卦、热点事件等实时内容',
    sameAs: [
      'https://weibo.com/jinrikankan',
    ],
  });

  const generateWebSiteSchema = () => ({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '今日看料',
    url: 'https://www.jinrikankan.com',
    description: '今日看料网入口聚合——覆盖网红爆料、娱乐圈八卦、PP料今日最新价格、黑料今日等实时内容',
    inLanguage: 'zh-CN',
  });

  const generateWebPageSchema = () => ({
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description: description,
    url: canonicalUrl,
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: '今日看料',
      url: 'https://www.jinrikankan.com',
    },
  });

  const generateArticleSchema = () => {
    if (!articleData) return null;
    return {
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline: title,
      description: description,
      url: canonicalUrl,
      datePublished: articleData.publishDate,
      dateModified: articleData.modifiedDate,
      author: {
        '@type': 'Person',
        name: articleData.authorName,
      },
      publisher: {
        '@type': 'Organization',
        name: '今日看料',
      },
      articleSection: articleData.category,
      keywords: articleData.tags.join(', '),
      inLanguage: 'zh-CN',
    };
  };

  const generateBreadcrumbSchema = () => {
    if (!breadcrumbItems || breadcrumbItems.length === 0) return null;
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: breadcrumbItems.map((item, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        name: item.name,
        item: item.url,
      })),
    };
  };

  const allSchemas = [
    generateOrganizationSchema(),
    generateWebSiteSchema(),
    generateWebPageSchema(),
  ];

  if (pageType === 'article') {
    const articleSchema = generateArticleSchema();
    if (articleSchema) allSchemas.push(articleSchema);
  }

  if (breadcrumbItems) {
    const breadcrumbSchema = generateBreadcrumbSchema();
    if (breadcrumbSchema) allSchemas.push(breadcrumbSchema);
  }

  if (schemaData) {
    allSchemas.push(schemaData);
  }

  return (
    <>
      {allSchemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
}